import TwitchChatbotSetup from "@/components/chatbots/twitch/twitch-chatbot-setup.jsx";
import CommandTable from "@/components/shared/command-table.jsx";

export default function TwitchChatbotPage() {
  const commands = [
    {
      command: "!creativetotal",
      description:
        "Together with the entire St. Jude PLAY LIVE Creative Season community, we have raised [total amount raised through St. Jude PLAY LIVE Creative Season] for the kids of St. Jude!",
    },
    {
      command: "!sjrecent",
      description: "Lists last 10 donations to the campaign",
    },
    {
      command: "!sjpolls",
      description: "Shows active donations polls and their rankings",
    },
    {
      command: "!sjlifetime",
      description: "Shows your total raised over your entire campaign's lifetime",
    },
    {
      command: "!sjrewards",
      description: "Lists all active campaign donation rewards",
    },
    {
      command: "!sjdiscord",
      description:
        "Check out the official St. Jude PLAY LIVE Discord to meet other fundraisers, ask questions, chat with staff and brainstorm ideas. Join us! https://discord.gg/stjudeplaylive",
    },
    {
      command: "!sjgiftshop",
      description:
        "Support the kids of St. Jude with a unique gift from our online St. Jude Gift Shop! Shop here: https://giftshop.stjude.org/",
    },
    {
      command: "!sjstatus",
      description: "Confirms if your chatbot is connected to your Tiltify campaign",
    },
    {
      command: "!sjcommands",
      description:
        "For a full list of chatbot commands go to https://www.stjude.org/playlivechatbot.",
    },
    {
      command: "!sjmatching",
      description:
        "Looking for an easy way to double or even triple your donation to St. Jude? Ask your employer if they will match your donation to St. Jude. Visit: https://www.stjude.org/SJPLmatch or email matchinggifts@stjude.org for more info.",
    },
    {
      command: "!sjraised",
      description:
        "Our community has raised [raised amount] for the kids of St. Jude! Help us reach our fundraising goal of [goal amount] by donating here: [campaign donation url]",
    },
    {
      command: "!sjgoal",
      description:
        "Our community has raised [raised amount] for the kids of St. Jude! Help us reach our fundraising goal of [goal amount] by donating here: [campaign donation url]",
    },
    {
      command: "!sjmilestones",
      description:
        "Help unlock our St. Jude campaign milestones! [list of milestones] Donate now: [campaign's donation url]",
    },
    {
      command: "!sjnextmilestone",
      description:
        "My next St. Jude campaign milestone at: [milestone dollar amount] will be to [milestone text]. Let’s go!",
    },
    {
      command: "!sjdonate",
      description:
        "I am raising money for the kids of St. Jude Children's Research Hospital. Help me reach my goal by donating now at [campaign's donation url]",
    },
    {
      command: "!sjstory",
      description:
        "St. Jude Inspire tells the stories of St. Jude Children's Research Hospital to inspire trust, hope and faith in the mission that drives us: Finding cures. Saving children. Learn more about St. Jude patients, families and supporters at https://stjude.org/inspire!",
    },
    {
      command: "!sjfact",
      description: "Chatbot will post random facts about St. Jude Children's Research Hospital",
    },
    {
      command: "!sjhelp",
      description: "List all the commands that the chatbot has to offer",
    },
    {
      command: "!plabout",
      description:
        "St. Jude PLAY LIVE is the video game charity platform supporting St. Jude Children’s Research Hospital. Whether it's Fortnite, League of Legends or Animal Crossing, you can play your favorite video games while helping raise funds and awareness for the lifesaving mission of St. Jude. Learn more at http://playlive.stjude.org",
    },
    {
      command: "!sjpart",
      description: "Removes chatbot from your channel",
    },
    {
      command: "!prizeseasontotal",
      description:
        "Together with the entire St. Jude PLAY LIVE community, we have raised [total amount raised through St. Jude PLAY LIVE] for the kids of St. Jude!",
    },
    {
      command: "!gcxtotal",
      description:
        "Together with the entire GCX community, we have raised raised [total amount raised through GCX event] for the kids of St. Jude!",
    },
    {
      command: "!5dono",
      description:
        "Your $5 donation could provide an isolation gown for a parent of a St. Jude kid. Thank you!",
    },
    {
      command: "!6dono",
      description:
        "Your $6 donation could provide an IV tubing kit for a St. Jude patient. Thank you!",
    },
    {
      command: "!7dono",
      description:
        "Your $7 donation could provide a blank medical teaching doll that helps St. Jude patients understand medical treatment procedures Thank you!",
    },
    {
      command: "!10dono",
      description:
        "Your $10 donation could provide a new toy for the hospital play areas. Thank you!",
    },
    {
      command: "!22dono",
      description:
        "Your $22 donation can help provide rehab weights for a St. Jude kid to help them regain strength and mobility Thank you!",
    },
    {
      command: "!25dono",
      description:
        "Your $25 donation can help provide a No More Chemo Party for a kid at St. Jude to help them celebrate the completion of chemotherapy treatment. Thank you!",
    },
    {
      command: "!30dono",
      description:
        "Your $30 donation could cover a full day of meals for a St. Jude family. Thank you!",
    },
    {
      command: "!50dono",
      description:
        "Your $50 donation can help provide art supplies for kids at St. Jude. At St. Jude patients are encouraged to express themselves through numerous art activities. Thank you!",
    },
    {
      command: "!57dono",
      description:
        "Your $57 donation can help provide necessities for parents who may have hurriedly left home after their child’s diagnosis. Thank you!",
    },
    {
      command: "!75dono",
      description:
        "Your $75 donation could provide video games for kids at St. Jude. While undergoing treatment, video games offer patients a welcome way to pass the time. Thank you!",
    },
    {
      command: "!100dono",
      description:
        "Your $100 donation can help provide a patient wagon at St. Jude. Red wagons are the preferred mode of travel through the halls of the hospital for our youngest patients. Thank you!",
    },
    {
      command: "!200dono",
      description:
        "Your $200 donation can help provide platelet count tests for four St. Jude patients. Thank you!",
    },
    {
      command: "!300dono",
      description:
        "Your $300 donation could help provide one red blood cell transfusion for a St. Jude patient. Thank you!",
    },
    {
      command: "!500dono",
      description:
        "Your $500 donation could help provide one platelet transfusion for a St. Jude patient. Thank you!",
    },
    {
      command: "!1000dono",
      description:
        "Your $1000 donation could help provide two-thirds of the cost of one day of chemotherapy for a St. Jude patient. Thank you!",
    },
    {
      command: "!2500dono",
      description:
        "Your $2500 donation could help provide 16 days of oxygen for a St. Jude patient. Thank you!",
    },
    {
      command: "!5000dono",
      description:
        "Your $5000 donation could help provide the daily room rate of the ICU for a St. Jude patient. Thank you!",
    },
  ];

  return (
    <>
      <TwitchChatbotSetup />
      <div className="divider" />
      <div>
        <h2 className="text-2xl mb-4" id="commands">
          Commands
        </h2>
        <div className="mt-4 mb-4">
          <CommandTable commands={commands} />
        </div>
      </div>
    </>
  );
}
